import {
  selectUserForceMove,
  selectUserForceMoveData,
  selectDelayThrottleFunction,
} from "modules/userForceMove/redux/selectors";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  subscribeEventUserNotification,
  unsubscribeEventUserNotification,
} from "services/firebaseService/eventUserNotifications";
import {
  selectCurrentEventId,
  selectIsEventManager,
} from "modules/event/selectors";
import { useUserForceMove } from "../useUserForceMove";

export const useUserForceMoveListener = () => {
  const shouldUserForceMove = useSelector(selectUserForceMove);
  const userForceMoveData = useSelector(selectUserForceMoveData);
  const currentEventId = useSelector(selectCurrentEventId);
  const isEventManager = useSelector(selectIsEventManager);
  const delayThrottleFunction = useSelector(selectDelayThrottleFunction);
  const { moveParticipant } = useUserForceMove();

  useEffect(() => {
    if (shouldUserForceMove && userForceMoveData && !isEventManager) {
      moveParticipant(userForceMoveData);
      delayThrottleFunction?.cancel();
    }
  }, [
    shouldUserForceMove,
    moveParticipant,
    userForceMoveData,
    delayThrottleFunction,
    isEventManager,
  ]);

  useEffect(() => {
    if (!currentEventId) {
      return undefined;
    }

    subscribeEventUserNotification(currentEventId);

    return () => {
      unsubscribeEventUserNotification(currentEventId);
    };
  }, [currentEventId]);
};
